import React from 'react';
import { ColorExplorer } from './components/ColorExplorer';
export function App() {
  return <div className="min-h-screen bg-background text-foreground antialiased" data-id="element-0">
      <ColorExplorer data-id="element-1" />
    </div>;
}